import { Card } from "uikit/components";
import styles from "./SchoolTrainingPlansView.module.styl";
import { arrayOf, exact, number, shape, string } from "prop-types";
import React from "react";
import SchoolTrainingPlansRow from "../SchoolTrainingPlansRow/SchoolTrainingPlansRow";

export default function SchoolTrainingPlansView({ groupsTrainingPlans }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="school_training_plans_form">
                <div className={styles.groupCode}>Код группы</div>
                <div className={styles.sportType}>Вид спорта</div>
                <div className={styles.sportTraining}>Этап подготовки - Год подготовки</div>
                <div className={styles.primaryCoachName}>Основной тренер</div>
                <div className={styles.secondaryCoachName}>Второй тренер</div>
                <div className={styles.trainingPlanInfo}>Планы тренировок</div>
                <div className={styles.trainingPlanPercent}>Наполнение</div>
            </div>
            <div>
                {groupsTrainingPlans?.map((item) => (
                    <SchoolTrainingPlansRow key={item.groupId} schoolTrainingPlan={item} />
                )) ?? []}
            </div>
        </Card>
    );
}

SchoolTrainingPlansView.propTypes = {
    groupsTrainingPlans: arrayOf(
        shape({
            groupId: number,
            groupCode: string,
            sportType: string,
            sportTrainingLevel: string,
            sportTrainingYear: number,
            primaryCoachName: exact({
                lastName: string.isRequired,
                firstName: string.isRequired,
                middleName: string,
                shortName: string.isRequired,
                fullName: string.isRequired,
                officialShortName: string.isRequired,
                officialFullName: string.isRequired,
                lastNameAndInitials: string.isRequired,
                firstNameAndMiddleName: string.isRequired,
            }),
            secondaryCoachName: exact({
                lastName: string.isRequired,
                firstName: string.isRequired,
                middleName: string,
                shortName: string.isRequired,
                fullName: string.isRequired,
                officialShortName: string.isRequired,
                officialFullName: string.isRequired,
                lastNameAndInitials: string.isRequired,
                firstNameAndMiddleName: string.isRequired,
            }),
            trainingPlan: exact({
                trainingsWithFilledPlanCount: number.isRequired,
                trainingsCount: number.isRequired,
                trainingsWithFilledPlanPercentage: number.isRequired,
            }),
        }),
    ).isRequired,
};
